import React from "react";
import {Tooltip, IconButton} from "@mui/material";
import {
    ArrowBack as ArrowBackIcon,
    Delete as DeleteIcon,
    ArrowForward as ArrowForwardIcon,
    Save as SaveIcon,
    Done as DoneIcon,
    Add as AddIcon,
    Download as DownloadIcon,
    Search as SearchIcon,
    ToggleOn as ToggleOnIcon,
    LockOpen as LockOpenIcon,
    Restore as RestoreIcon,
    RuleFolder as RuleFolderIcon,
    PersonOff as PersonOffIcon,
    PhonelinkLock as PhonelinkLockIcon,
    LockReset as LockResetIcon,
    CurrencyExchange as CurrencyExchangeIcon,
    Unsubscribe as UnsubscribeIcon,
    Handshake as HandshakeIcon,
    School as SchoolIcon,
    Gavel as GavelIcon,
    Paid as PaidIcon,
    RequestPage as RequestPageIcon,
    Print as PrintIcon,
    Edit as EditIcon,
    Visibility,
    PictureAsPdf,
} from "@mui/icons-material";
import Check from "@material-ui/icons/Check";

const iconMap = {
    back: <ArrowBackIcon/>,
    borrar: <DeleteIcon/>,
    next: <ArrowForwardIcon/>,
    save: <SaveIcon/>,
    fin: <DoneIcon/>,
    nuevo: <AddIcon/>,
    descargar: <DownloadIcon/>,
    buscar: <SearchIcon/>,
    activar: <ToggleOnIcon/>,
    desbloquear: <LockOpenIcon/>,
    restaurar: <RestoreIcon/>,
    libreta: <RuleFolderIcon/>,
    cancelar: <PersonOffIcon/>,
    generarClaveDisp: <PhonelinkLockIcon/>,
    restaurarClave: <LockResetIcon/>,
    desbloquearSaldo: <CurrencyExchangeIcon/>,
    darDeBaja: <UnsubscribeIcon/>,
    conciliar: <HandshakeIcon/>,
    graduar: <SchoolIcon/>,
    gavel: <GavelIcon/>,
    pay: <PaidIcon/>,
    requestPay: <RequestPageIcon/>,
    anular: <DeleteIcon/>,
    imprimir: <PrintIcon/>,
    editar: <EditIcon/>,
    ver: <Visibility/>,
    pdf: <PictureAsPdf/>,
    check: <Check/>,
};

const colorMap = {
    borrar: "#e53935",
    anular: "#e53935",
    save: "#43a047",
    nuevo: "#1e88e5",
    check: "#43a047",
    fin: "#8e24aa",
    descargar: "#039be5",
    cancelar: "#fb8c00",
    restaurar: "#00acc1",
    desbloquear: "#26a69a",
    pay: "#43a047",
    requestPay: "#3949ab",
    imprimir: "#5e35b1",
    editar: "#fbc02d",
};

export default function FooterButton({
                                         etiqueta,
                                         tipo,
                                         icono,
                                         disabled = false,
                                         onClick,
                                     }) {
    const icon = icono || iconMap[tipo] || <DoneIcon/>;
    const bgColor = colorMap[tipo] || "#90a4ae";

    return (
        <Tooltip title={etiqueta}>
            <IconButton
                aria-label={etiqueta}
                disabled={disabled}
                onClick={onClick}
                sx={{
                    width: 38,
                    height: 38,
                    backgroundColor: disabled ? "#ccc" : bgColor,
                    color: "#fff",
                    margin: 1,
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                    "&:hover": {
                        backgroundColor: disabled ? "#ccc" : bgColor,
                        transform: "scale(1.15)",
                        boxShadow: "0 6px 12px rgba(0,0,0,0.25)",
                    },
                    "& svg": {
                        fontSize: 32,
                    },
                    transition: "all 0.2s ease-in-out",
                }}
            >
                {icon}
            </IconButton>
        </Tooltip>
    );
}
